import { chunk, cloneDeep, unionWith } from "lodash-es";

import {
  firstDateOfMonth,
  weekDays,
  isGt,
  getDate,
  getYearMonthDate,
  visibleDays,
} from "../calendar";

import {
  getServiceInfo,
  isPbMenu,
  computeMenuRatio,
  sortMenus,
  getApiWeekdays,
  isAllPublished,
  findServiceTime,
  computePickupTime,
  findSiblingServiceTime,
  getPlans,
  getParentServiceTime,
} from "./functions";

const DEFAULT_CUSTOMER = { id: 93, name: "열두달" };

const DEFAULT_FIRSTDATE = firstDateOfMonth(new Date());

const DEFAULT_STATE = {
  customer: DEFAULT_CUSTOMER,
  pbMenus: [],
  menuRatio: [],
  serviceTimes: [],
  firstDate: DEFAULT_FIRSTDATE,
  meals: [],
  isDraggingMenu: false,
  isOpenDlgSubmenu: false,
  dlgServiceTime: {
    open: false,
    menu: null,
    target: null,
    disablePbMenu: false,
  },
  dlgCustomerList: { open: false },
  dlgServicePlan: {
    open: false,
    menu: null,
  },
  focusedMenu: null, // 선택된 메뉴 식별 정보
  currentPatch: null,
  curationGroupId: null, // 큐레이션 그룹 id
};

const MENU_PLACEHOLDER = {
  published: false,
  id: null,
  date: null,
  serviceTime: null,
  menuType: "1",
  menuId: null,
  menu: null,
  supplierId: null,
  supplier: null,
  subMenu: [],
  pickupTime: null,
  orderQty: null,
  memo: null,
  // ...
};

// state key
export const scheduleMeals = "scheduleMeals";

// actions
export const SET_CUSTOMER = "customer-order/set-customer";
export const SET_FIRSTDATE = "customer-order/set-firstdate";
export const SET_MEALS = "CST_SET_MEALS";
export const SET_SUGGESTION = "customer-order/set-suggestion";
export const ADD_SERVICETIME = "customer-order/add-servicetime";
export const ADD_MENU = "CST_ADD_MENU";
export const UPDATE_PB_MENU = "customer-order/update-pb-menu";
export const DELETE_MENU = "CST_DELETE_MENU";
export const DELETE_SUBMENU = "CST_DELETE_SUBMENU";
export const UPDATE_SUBMENU = "customer-order/update-submenu";
export const UPDATE_MEMO = "customer-order/update-memo";
export const UPDATE_PUBLISH = "customer-order/update-publish";
export const UPDATE_PLAN = "customer-order/update-plan";
export const ADD_DONTHAVE = "customer-order/add-donthave";
export const REMOVE_DONTHAVE = "customer-order/remove-donthave";
// export const START_DRAG_MENU = 'CST_START_DRAG_MENU';
// export const QUIT_DRAG_MENU = 'CST_QUIT_DRAG_MENU';
export const OPEN_DLG_SUBMENU = "customer-order/open-dlg-submenu";
export const CLOSE_DLG_SUBMENU = "customer-order/close-dlg-submenu";
export const OPEN_DLG_SERVICETIME = "customer-order/open-dlg-servicetime";
export const CLOSE_DLG_SERVICETIME = "customer-order/close-dlg-servicetime";
export const OPEN_DLG_CUSTOMER_LIST = "customer-order/open-dlg-customer-list";
export const CLOSE_DLG_CUSTOMER_LIST = "customer-order/close-dlg-customer-list";
export const OPEN_DLG_SERVICE_PLAN = "customer-order/open-dlg-service-plan";
export const CLOSE_DLG_SERVICE_PLAN = "customer-order/close-dlg-service-plan";
export const SET_PATCH_DELETION = "customer-order/set_patch_deletion";
export const SET_PATCH_ADDTION = "customer-order/set_patch_addtion";
export const ON_MENU_SAVED = "customer-order/on_menu_saved";
export const ON_MENU_PUBLISHED = "customer-order/on_menu_published";
export const SET_CURATION_GROUP_ID = "customer-order/set-curation-group-id";
export const SET_DEFAULT_PLAN = "customer-order/set-default-plan";

// export cosnt clear_

// reducer
export default (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case SET_CUSTOMER:
      return {
        ...state,
        customer: payload.customer,
      };

    case SET_FIRSTDATE:
      return {
        ...state,
        firstDate: payload.firstDate,
      };

    case SET_MEALS: {
      const { meals, lockedMeals, customer, pbMenus } = payload;

      // apply lock info
      meals.forEach((m) => {
        const locked = lockedMeals.some(
          (l) => l.date === m.date && l.serviceTime === m.serviceTime
        );
        if (locked) {
          m.menu.forEach((menu) => {
            menu.lock = true;
          });
        }
      });

      // apply customer service types
      // const deliveryGroup = meals.find(m => m.deliveryGroup)?.deliveryGroup ?? null;
      const serviceMeals = getServiceInfo(
        customer.serviceTime,
        state.firstDate
      );
      serviceMeals.forEach((sm) => {
        let found = meals.find(
          (m) => m.date === sm.date && m.serviceTime === sm.serviceTime
        );

        if (!found) {
          found = {
            date: sm.date,
            serviceTime: sm.serviceTime,
            customerId: customer.id,
            customerName: customer.name,
            // deliveryGroup,
            menu: [],
          };
          meals.push(found);
        }

        sm.services.forEach((service) => {
          const hasMenu = found.menu.some((menu) => {
            if (menu.supplier) {
              // supplier 있는 경우 serviceType 으로 판별
              return service.id === 47
                ? menu.supplier.serviceType.some((el) => el.id === 47)
                : menu.supplier.serviceType.some((el) =>
                    [45, 46].includes(el.id)
                  );
            } else if (menu.menuType !== "2" && menu.menuId === null) {
              // placeholder 경우 serviceType(empty 만 존재) field 로 확인
              return service.id === 47
                ? menu.serviceType === "pb"
                : menu.serviceType === "normal";
            } else {
              return false;
            }
          });
          if (!hasMenu) {
            found.menu.push({
              ...MENU_PLACEHOLDER,
              date: sm.date,
              serviceTime: sm.serviceTime,
              menuType: "1", // placeholder menuType - 1
              serviceType: service.id === 47 ? "pb" : "normal",
            });
          }
        });

        // arrangeMenus(found);
        sortMenus(found.menu);
      });

      // calculate ratio
      const menuRatio = computeMenuRatio(customer.menuRatio, meals);

      // service times 
      customer.serviceTime.sort((a, b) => {
        if (a.serviceTime < b.serviceTime) return -1;
        else if (a.serviceTime > b.serviceTime) return 1;
        else return 0;
      });

      // default plan 
      customer.serviceTime.forEach(st => {
        // servicePlan.tierPrice 없는 경우, serviceTime.price 적용 
        st.servicePlan.forEach(sp => {
          if (sp.pricingModel === 'tiered' && !sp.tierPrice) {
            sp.tierPrice = st.price;
          }
        });

        // Note: 현시점 mealbox 만 지원 
        const mealboxPlan = st.servicePlan.find(sp => sp.serviceTypeId === 45);
        st.defaultPlan = mealboxPlan ?? st.servicePlan[0] ?? null;
      });

      return {
        ...state,
        pbMenus,
        serviceTimes: customer.serviceTime,
        meals,
        menuRatio,
      };
    }

    case SET_SUGGESTION: {
      const { suggestions } = payload;
      const newMeals = cloneDeep(state.meals);
      suggestions.forEach((s) => {
        // find date-serviceTime meals item
        let destMeal = newMeals.find(
          (m) => m.date === s.date && m.serviceTime === s.serviceTime
        );

        if (destMeal) {
          // update menu items with suggetions
          s.menu.forEach((sgstMenu) => {
            // find a same service type
            // 큐레이션 메뉴 적용하는 기존 로직 (푸딩 정책 변경될 수 있음)
            /* let found = destMeal.menu.find(dstMenu => {
            if (sgstMenu.menuType === '2') {
              return dstMenu.menuType === '2';
            }
            else {
              const isPb = isPbMenu(dstMenu);
              return isPbMenu(sgstMenu) ? isPb : !isPb;
            }
          }); */
            if (sgstMenu.menuType === "2") {
              // update or add menuType 2
              const destMenu = destMeal.menu.find(
                (menu) => menu.menuType === "2"
              );
              if (destMenu) {
                if (!destMenu.published && !destMenu.lock) {
                  Object.assign(destMenu, sgstMenu);
                } else {
                  // check logic!
                  console.warn("check logic! published or locked suggestion!");
                }
              } else {
                destMeal.menu.push(sgstMenu);
              }
            } else {
              // 기존 기본 메뉴
              const defaultMenu = destMeal.menu.find(
                (menu) => menu.menuType === "0"
              );
              if (defaultMenu) {
                const isDefaultPb = isPbMenu(defaultMenu);
                const isSgstPb = isPbMenu(sgstMenu);
                const isSameType = isSgstPb ? isDefaultPb : !isDefaultPb;
                if (isSameType) {
                  // lock check?
                  Object.assign(defaultMenu, sgstMenu);
                } else {
                  // 다른 경우 기존 기본 메뉴는 menuType 1 로 변경
                  const destMenu = destMeal.menu.find((menu) => {
                    const isPb = isPbMenu(menu);
                    return isSgstPb ? isPb : !isPb;
                  });
                  if (destMenu) {
                    // lock check?
                    Object.assign(destMenu, sgstMenu);
                  } else {
                    destMeal.menu.push(sgstMenu);
                  }
                  defaultMenu.menuType = "1";
                }
              } else {
                // 기존 기본 메뉴 없는 경우 같은 serviceType 덮어쓰거나 추가
                const isSgstPb = isPbMenu(sgstMenu);
                const destMenu = destMeal.menu.find((menu) => {
                  const isPb = isPbMenu(menu);
                  return isSgstPb ? isPb : !isPb;
                });
                if (destMenu) {
                  // lock check ?
                  Object.assign(destMenu, sgstMenu);
                } else {
                  destMeal.menu.push(sgstMenu);
                }
              }
            }
          });

          sortMenus(destMeal.menu);
        } else {
          // insert suggestions
          // (logically impossible)
          newMeals.push(s);
        }
      });

      // calculate ratio
      const menuRatio = computeMenuRatio(state.menuRatio, newMeals);

      return {
        ...state,
        meals: newMeals,
        menuRatio,
      };
    }

    case ADD_SERVICETIME: {
      const { date, serviceTime, serviceTypes, target, dayOnly } = payload;

      const dates = [];

      dates.push(date);

      if (!dayOnly) {
        // 모든 주 같은 요일 수집

        const selectedDate = getDate(date);
        weekDays(selectedDate).forEach((d) => {
          const day = d.getDay();
          if (day !== 0 && day !== 6) {
            dates.push(getYearMonthDate(d));
          }
        });

        /*
      // 기획 변경으로 기존 로직 주석처리 (원복 가능성)
      // 이전 주
      const firstDay = firstVisibleDay(state.firstDate);
      let d = getPrevWeekDay(selectedDate);
      while (isLte(firstDay, d)) {
        dates.push(getYearMonthDate(d));
        d = getPrevWeekDay(d);
      }

      // 이후 주
      const lastDay = lastVisibleDay(state.firstDate);
      d = getNextWeekDay(selectedDate);
      while (isGte(lastDay, d)) {
        dates.push(getYearMonthDate(d));
        d = getNextWeekDay(d);
      } */
      }

      // empty meal 추가
      const { id: customerId, name: customerName } = state.customer;
      // const deliveryGroup = state.meals.find(m => m.deliveryGroup)?.deliveryGroup ?? null;

      const emptyMeals = dates.map((el) => ({
        date: el,
        serviceTime,
        customerId,
        customerName,
        // deliveryGroup,
        menu: [],
      }));

      let newMeals = unionWith(
        state.meals,
        emptyMeals,
        (a, b) => a.date === b.date && a.serviceTime === b.serviceTime
      ).sort((a, b) => {
        if (a.date === b.date) {
          return a.serviceTime < b.serviceTime ? -1 : 1;
        } else {
          return a.date < b.date ? -1 : 1;
        }
      });

      // empty menu 추가
      newMeals = newMeals.map((m) => {
        if (dates.includes(m.date) && serviceTime === m.serviceTime) {
          // service type 별로 해당 menu 추가
          const newMeal = cloneDeep(m);
          serviceTypes.forEach((type) => {
            const hasMenu = newMeal.menu.some((menu) => {
              if (menu.supplier) {
                return type === "pb"
                  ? menu.supplier.serviceType.some((el) => el.id === 47)
                  : menu.supplier.serviceType.some((el) =>
                      [45, 46].includes(el.id)
                    );
              } else if (menu.menuType !== "2") {
                return menu.serviceType === type;
              } else {
                return false;
              }
            });
            if (!hasMenu || target === "menu") {
              newMeal.menu.push({
                ...MENU_PLACEHOLDER,
                date: m.date,
                serviceTime: m.serviceTime,
                menuType: "1",
                serviceType: type,
              });
            }
          });

          sortMenus(newMeal.menu);
          return newMeal;
        } else {
          return m;
        }
      });

      return {
        ...state,
        meals: newMeals,
      };
    }

    case ADD_MENU: {
      const { selectedMenu } = payload;

      if (!selectedMenu) return state;

      const { date, serviceTime, menuType } = payload;

      // check existing menus
      const destMeal = state.meals.find(
        (meal) => meal.date === date && meal.serviceTime === serviceTime
      );
      if (destMeal.menu.some((menu) => menu.menuId === selectedMenu.id)) {
        return state;
      }

      const newMeals = state.meals.map((item) => {
        if (item.date === date && item.serviceTime === serviceTime) {
          // empty mealbox에 선택된 menu 채워넣기
          const newMeal = cloneDeep(item);
          const emptyMenu = newMeal.menu.find(
            (m) => m.menuType === menuType && !m.menu
          ); // menuType 조건 삭제?

          const srcData = {
            customerId: state.customer.id,
            published: false,
            menuId: selectedMenu.id,
            menu: {
              id: selectedMenu.id,
              name: selectedMenu.name,
              menuCategory: selectedMenu.menuCategory,
              price: selectedMenu.price,
            },
            supplierId: selectedMenu.supplierId,
            supplier: selectedMenu.supplier,
            subMenu: selectedMenu.subMenu ?? [],
            customerPrice: null,
            pickupTime: null,
            orderQty: null,
            memo: null,
            // ...
          };

          // service time & plan 

          // leave legacy code for reference
          /* const foundService = findServiceTime(
            state.serviceTimes,
            date,
            serviceTime,
          );
          if (foundService) {
            // customer price
            srcData.customerPrice = foundService.price;
            // pickup time
            srcData.pickupTime = computePickupTime(foundService.timeFrom);
          } else {
            // 일치하는 서비스타임 없는 경우 같은 서비스타임 참고
            const siblingService = findSiblingServiceTime(
              state.serviceTimes,
              serviceTime
            );
            if (siblingService) {
              srcData.customerPrice = siblingService.price;
              srcData.pickupTime = computePickupTime(siblingService.timeFrom);
            } else {
              console.error(
                `No service time for ${srcData.customerId} on ${date}`
              );
            }
          }

          // service plan 
          srcData.servicePlanId = foundService?.defaultPlan?.id ?? null; */

          const plans = getPlans(state.serviceTimes, { date, serviceTime });
          if (plans?.length > 0) {
            const serviceTime = getParentServiceTime(state.serviceTimes, plans[0]);
            const defaultPlan = serviceTime.defaultPlan ?? plans[0];
            srcData.customerPrice = defaultPlan.tierPrice ?? serviceTime.price;
            srcData.servicePlanId = defaultPlan.id;
            srcData.pickupTime = computePickupTime(serviceTime.timeFrom);
          }
          else {
            // 일치하는 서비스타임 없는 경우 같은 서비스타임 참고
            const siblingService = findSiblingServiceTime(
              state.serviceTimes,
              serviceTime
            );
            if (siblingService) {
              srcData.customerPrice = siblingService.price;
              srcData.servicePlanId = siblingService.defaultPlan?.id ?? null;
              srcData.pickupTime = computePickupTime(siblingService.timeFrom);
            } else {
              console.error(
                `No service time for ${srcData.customerId} on ${date}`
              );
            }
          }          

          Object.assign(emptyMenu, srcData);
          return newMeal;
        } else {
          return item;
        }
      });

      // calculate ratio
      const menuRatio = computeMenuRatio(state.menuRatio, newMeals);

      return {
        ...state,
        meals: newMeals,
        menuRatio,
      };
    }

    case UPDATE_PB_MENU: {
      const { date, serviceTime, pbMenu } = payload;
      const newMeals = state.meals.map((meal) => {
        if (meal.date === date && meal.serviceTime === serviceTime) {
          const newMeal = cloneDeep(meal);
          const destMenu = newMeal.menu.find((el) => isPbMenu(el));
          Object.assign(destMenu, {
            menuId: pbMenu?.id ?? null,
            menu: pbMenu
              ? {
                  id: pbMenu.id,
                  name: pbMenu.name,
                  menuCategory: pbMenu.menuCategory,
                }
              : null,
            supplierId: pbMenu?.supplier.id ?? null,
            supplier: pbMenu?.supplier ?? null,
          });
          return newMeal;
        } else {
          return meal;
        }
      });

      // calculate ratio
      const menuRatio = computeMenuRatio(state.menuRatio, newMeals);

      return {
        ...state,
        meals: newMeals,
        menuRatio,
      };
    }

    case DELETE_MENU: {
      const { date, serviceTime, menuId } = payload;
      /* const newMeals = state.meals.map((item) => {
        if (item.date === date && item.serviceTime === serviceTime) {
          item.menu = item.menu.filter((menu) => menu.menuId !== menuId);
        }
        return item;
      }); */
      // 단순 삭제는 위와 같으나, menuType/순서 등 유지 위해 아래 방식 적용 
      const newMeals = state.meals.map((item) => {
        if (item.date === date && item.serviceTime === serviceTime) {
          const newMeal = cloneDeep(item);
          // unlock ? TODO
          const menu = newMeal.menu.find((m) => m.menuId === menuId);
          // clear menu data
          const emptyMenu = {
            // id: null,
            published: false,
            menuId: null,
            menu: null,
            supplierId: null,
            supplier: null,
            supplierPrice: null,
            customerPrice: null,
            subMenu: [],
            pickupTime: null,
            orderQty: null,
            maxOrderQty: null,
            amountQty: null,
            memo: null,
            serviceType: "normal",
            servicePlanId: null,
            // ...
          };
          Object.assign(menu, emptyMenu);
          sortMenus(newMeal.menu);
          return newMeal;
        } else {
          return item;
        }
      });

      // calculate ratio
      const menuRatio = computeMenuRatio(state.menuRatio, newMeals);

      return {
        ...state,
        meals: newMeals,
        menuRatio,
      };
    }

    case DELETE_SUBMENU: {
      const { date, serviceTime, menuId, subMenuId } = payload;
      const newMeals = state.meals.map((item) => {
        // unlock ?
        if (item.date === date && item.serviceTime === serviceTime) {
          const newMeal = cloneDeep(item);
          const menu = newMeal.menu.find((m) => m.menuId === menuId);
          menu.subMenu = menu.subMenu.filter((sm) => sm.id !== subMenuId);
          return newMeal;
        } else {
          return item;
        }
      });
      return {
        ...state,
        meals: newMeals,
      };
    }

    case UPDATE_SUBMENU: {
      const { date, serviceTime, menuId, subMenus } = payload;
      const newMeals = state.meals.map((item) => {
        if (item.date === date && item.serviceTime === serviceTime) {
          // unlock ?
          const newMeal = cloneDeep(item);
          const menu = newMeal.menu.find((m) => m.menuId === menuId);
          menu.subMenu = subMenus;
          return newMeal;
        } else {
          return item;
        }
      });
      return {
        ...state,
        meals: newMeals,
      };
    }

    case UPDATE_MEMO: {
      const { date, serviceTime, menuId, memo } = payload;
      const newMeals = state.meals.map((item) => {
        if (item.date === date && item.serviceTime === serviceTime) {
          const newMeal = cloneDeep(item);
          const menu = newMeal.menu.find((m) => m.menuId === menuId);
          menu.memo = memo;
          return newMeal;
        } else {
          return item;
        }
      });

      return {
        ...state,
        meals: newMeals,
      };
    }

    case UPDATE_PUBLISH: {
      const { dates, publish } = payload;
      const publishedDates = dates.map((day) => getYearMonthDate(day));
      const newMeals = state.meals.map((m) => {
        if (publishedDates.includes(m.date)) {
          const newMeal = cloneDeep(m);
          newMeal.menu.forEach((menu) => (menu.published = publish));
          return newMeal;
        } else {
          return m;
        }
      });

      return {
        ...state,
        meals: newMeals,
      };
    }

    case UPDATE_PLAN: {
      const { menu, servicePlanId } = payload;
      const newMeals = state.meals.map(meal => {
        if (meal.date === menu.date && meal.serviceTime === menu.serviceTime) {
          const newMeal = cloneDeep(meal);
          const newMenu = newMeal.menu.find(m => m.menuId === menu.menuId);
          newMenu.servicePlanId = servicePlanId;
          return newMeal;
        }
        else {
          return meal;
        }
      });

      return {
        ...state, 
        meals: newMeals,
      };
    }

    case ADD_DONTHAVE: {
      // weeks' published states
      // const datesOfMonth = visibleDays(state.firstDate, 0); //NOTE: week for api
      const datesOfMonth = visibleDays(state.firstDate); //NOTE: week for api
      const weeks = chunk(datesOfMonth, 7);
      const weeksPublished = weeks.map((week) =>
        isAllPublished(week, state.meals)
      );

      const newMeals = state.meals.map((meal) => {
        // published 된 주문 있는 경우 해당 meal 은 published 된 것으로 판단
        if (meal.menu.some((menu) => menu.published || menu.lock)) {
          return meal;
        }

        // published 된 주문 없는 경우, 속하는 week 의 publish 여부로 판단
        if (
          meal.menu.filter(
            (menu) => menu.menuId !== null || menu.menuType === "2"
          ).length === 0
        ) {
          // check a week is published
          const weekIdx = weeks.findIndex((week) =>
            week.map((day) => getYearMonthDate(day)).includes(meal.date)
          );
          if (weeksPublished[weekIdx]) {
            return meal;
          }
        }

        const newMeal = cloneDeep(meal);
        newMeal.menu.push({
          ...MENU_PLACEHOLDER,
          date: newMeal.date,
          serviceTime: newMeal.serviceTime,
          menuType: "2",
        });
        return newMeal;
      });

      return {
        ...state,
        meals: newMeals,
      };
    }

    case REMOVE_DONTHAVE: {
      // api에서 기존 '안 먹을래요' 삭제 조건
      // - id: 존재, menuType: '2', menuId: 0
      const newMeals = state.meals.map((meal) => {
        if (
          meal.menu.some(
            (menu) => !menu.published && !menu.lock && menu.menuType === "2"
          )
        ) {
          const newMeal = cloneDeep(meal);
          newMeal.menu = newMeal.menu
            .filter((menu) => menu.id !== null || menu.menuType !== "2") // remove that hasn't saved yet
            .map((menu) => {
              if (menu.menuType === "2") {
                // set menuId 0 to remove existing one
                menu.menuId = 0;
              }
              return menu;
            });
          return newMeal;
        } else {
          return meal;
        }
      });

      return {
        ...state,
        meals: newMeals,
      };
    }

    /* case START_DRAG_MENU: {
    return {
      ...state,
      isDraggingMenu: true
    };
  }
  case QUIT_DRAG_MENU: {
    return {
      ...state,
      isDraggingMenu: false
    };
  } */

    case OPEN_DLG_SUBMENU: {
      const { date, serviceTime, menuId } = payload;
      return {
        ...state,
        isOpenDlgSubmenu: true,
        focusedMenu: {
          date,
          serviceTime,
          menuId,
        },
      };
    }

    case CLOSE_DLG_SUBMENU: {
      return {
        ...state,
        isOpenDlgSubmenu: false,
        focusedMenu: null,
      };
    }

    case OPEN_DLG_SERVICETIME: {
      const { date, serviceTime, target } = payload;

      const disablePbMenu =
        target === "menu" &&
        state.meals
          .find((m) => m.date === date && m.serviceTime == serviceTime)
          .menu.some((menu) => isPbMenu(menu));

      return {
        ...state,
        dlgServiceTime: {
          open: true,
          menu: { date, serviceTime },
          target,
          disablePbMenu,
        },
      };
    }

    case CLOSE_DLG_SERVICETIME: {
      return {
        ...state,
        dlgServiceTime: {
          open: false,
          menu: null,
          target: null,
          disablePbMenu: false,
        },
      };
    }

    case OPEN_DLG_CUSTOMER_LIST: {
      return {
        ...state,
        dlgCustomerList: {
          open: true,
        },
      };
    }

    case CLOSE_DLG_CUSTOMER_LIST: {
      return {
        ...state,
        dlgCustomerList: {
          open: false,
        },
      };
    }

    case OPEN_DLG_SERVICE_PLAN: {
      const { menu } = payload;
      return {
        ...state,
        dlgServicePlan: {
          open: true,
          menu: menu,
        },
      };
    }

    case CLOSE_DLG_SERVICE_PLAN: {
      return {
        ...state,
        dlgServicePlan: {
          open: false,
          menu: null,
        },
      };
    }

    case SET_PATCH_DELETION: {
      const { menu } = payload;

      return {
        ...state,
        currentPatch: {
          date: menu.date,
          serviceTime: menu.serviceTime,
          deletion: menu,
          addition: null,
        },
      };
    }

    case SET_PATCH_ADDTION: {
      const { menu } = payload;

      return {
        ...state,
        currentPatch: Object.assign(state.currentPatch, {
          addition: menu,
        }),
      };
    }

    case ON_MENU_SAVED: {
      const { date, serviceTime, menuId, id } = payload;

      // find the menu
      const newMeals = state.meals.map((el) => {
        if (el.date === date && el.serviceTime === serviceTime) {
          const newMeal = cloneDeep(el);
          const savedMenu = newMeal.menu.find((m) => m.menuId === menuId);
          savedMenu.id = id;
          return newMeal;
        } else {
          return el;
        }
      });

      return {
        ...state,
        meals: newMeals,
      };
    }

    case SET_CURATION_GROUP_ID: {
      const { curationGroupId } = payload;

      return {
        ...state,
        curationGroupId,
      };
    }

    case SET_DEFAULT_PLAN: {
      const { serviceTime, servicePlan } = payload;

      const newServiceTimes = state.serviceTimes.map(st => {
        if (st.id === serviceTime.id) {
          st.defaultPlan = servicePlan;
        }
        return st;
      });

      return {
        ...state,
        serviceTimes: newServiceTimes,
      };
    }

    default:
      return state;
  }
};

export const selectCustomer = (state) => state.scheduleMeals.customer;

export const selectFirstDate = (state) => state.scheduleMeals.firstDate;

export const selectMeals = (state) => state.scheduleMeals.meals;

export const selectMenu = (state, date, serviceTime, menuId) => {
  if (date === null || serviceTime === null || menuId === null) {
    return null;
  }

  const meal = state.scheduleMeals.meals.find(
    (meal) => meal.date === date && meal.serviceTime === serviceTime
  );
  const menu = meal.menu.find((menu) => menu.menuId === menuId);
  return menu;
};

export const selectIsOpenSubMenuDialog = (state) =>
  state.scheduleMeals.isOpenDlgSubmenu;

export const selectFocusedMenu = (state) => state.scheduleMeals.focusedMenu;

export const selectDialogStateServiceTime = (state) =>
  state.scheduleMeals.dlgServiceTime;

export const selectDialogCustomerList = (state) =>
  state.scheduleMeals.dlgCustomerList;

export const selectDialogSerivcePlan = (state) => 
  state.scheduleMeals.dlgServicePlan;

export const selectPbMenus = (state) => state.scheduleMeals.pbMenus;

export const selectMenuRatio = (state) => state.scheduleMeals.menuRatio;

export const selectServiceTimes = (state) => state.scheduleMeals.serviceTimes;

export const selectIsPublished = (state, week) => {
  // 변경된 publish 취소 로직 (today 이전은 취소 못함) 반영
  // 오늘 이후만 확인할 경우 필터링 추가할 것
  const dates = getApiWeekdays(week);
  return isAllPublished(dates, state.scheduleMeals.meals);
};

export const selectPublishedDates = (state, dates) => {
  return dates.filter((day) => {
    const dayString = getYearMonthDate(day);
    return state.scheduleMeals.meals.some(
      (meal) =>
        meal.date === dayString && meal.menu.some((menu) => menu.published)
    );
  });
};

export const selectCurrentPath = (state) => state.scheduleMeals.currentPatch;

export const selectCurationGroupId = (state) =>
  state.scheduleMeals.curationGroupId;
